export default ({
  landingPageCatalog: {
    catalogLinks,
    content
  } = {}
} = {}) => ({ catalogLinks, content })
